import { useWebsocket } from "../useWebsocket";
import type { TNotification } from "@/api/models/message/notification";

export const useStaffSubscription = () => {
  const { subscribe, unsubscribe } = useWebsocket();

  const subscribeStaff = (staffId: string, onStaffEvent: (event: TNotification) => void) => {
    subscribe(`/staff/${staffId}/notifications`, (body) => {
      const event = JSON.parse(body) as TNotification;
      onStaffEvent(event);
    });
  };

  const unsubscribeStaff = (staffId: string) => {
    unsubscribe(`/staff/${staffId}/notifications`);
  };

  return {
    subscribeStaff,
    unsubscribeStaff,
  };
};
